import { useState, useCallback } from 'react'
import WojewodztwoService from '@/services/WojewodztwoService'
import useKlienciListFilters from '@/pages/klienci/common/useKlienciListFilters'

export default function useWojewodztwaData() {
	const { filters, updateFilters, searchQuery } = useKlienciListFilters('wojewodztwa')
	const [data, setData] = useState([])
	const [loading, setLoading] = useState(true)
	const [loadingMore, setLoadingMore] = useState(false)
	const [error, setError] = useState(null)
	const [totalCount, setTotalCount] = useState(0)
	const [hasMore, setHasMore] = useState(false)
	const [sortColumn, setSortColumn] = useState('_id')
	const [sortDirection, setSortDirection] = useState('desc')
	const [limit, setLimit] = useState(50)

	const loadData = useCallback(async () => {
		setLoadingMore(prevLoadingMore => {
			if (!prevLoadingMore) setLoading(true)
			return prevLoadingMore
		})
		setError(null)

		const searchText = (filters.searchText || '').trim()
		const requestOptions = { limit, sortColumn, sortDirection }
		const result = searchText
			? await WojewodztwoService.search(searchText, requestOptions)
			: await WojewodztwoService.getAll(requestOptions)

		if (result.error) {
			setError(result.error)
			setData([])
			setTotalCount(0)
			setHasMore(false)
		} else {
			setData(result.data)
			setTotalCount(result.totalCount)
			setHasMore(result.hasMore)
		}

		setLoading(false)
		setLoadingMore(false)
	}, [limit, sortColumn, sortDirection, filters])

	const handleLoadMore = useCallback(() => {
		if (hasMore && !loadingMore) {
			setLimit(prev => prev + 50)
			setLoadingMore(true)
		}
	}, [hasMore, loadingMore])

	const setSorting = useCallback((column, direction) => {
		setSortColumn(column)
		setSortDirection(direction)
	}, [])

	const clearError = useCallback(() => {
		setError(null)
	}, [])

	return {
		data,
		loading,
		loadingMore,
		error,
		totalCount,
		hasMore,
		loadData,
		handleLoadMore,
		setSorting,
		updateFilters,
		sortColumn,
		sortDirection,
		searchQuery,
		filters,
		clearError,
	}
}
